
export const APP_GROUP_ROUTES = {
    BASE: '/app/*',
    DASHBOARD: `/dashboard/*`,
    BIOMARKERS: `/biomarkers/*`,
    FOOD_INTOLERANCE: `/food-intolerance/*`,
    RECOMMENDATIONS: `/recommendations/*`,
    CUSTOMER_MANAGEMENT: `/customer-management/*`,
    CUSTOMER_RESULTS: `/customer-results/*`,
    CONTENT_PLAYGROUND: '/content-playground/*',
    FOOD_AND_DIET: '/food-and-diet/*',
    PROGRAMS: '/programs/*',
    USER_SEGMENTS: '/user-segments/*',
    FITNESS: '/fitness/*',
    HEALTH_PROGRAM: '/health-program/*',
    MEALPLAN: '/mealplan/*',
    UI_CUSTOMISATION: '/ui-customisation/*',
    ORGANISATIONS: '/organisations',
    CONTENTS: '/contents/*',
    MOBILE_APP_CUSTOMISATION: '/mobile-app-customisation/*',
    NOTIFICATIONS: '/notifications/*',
    ADMINS: '/admins/*',
    PRACTITIONERS: '/practitioners',
    SAMPLES_PAGE: '/samples/*',
};

export const APP_GROUP_LINKS = {
    BASE: '/app',
    DASHBOARD: `/app/dashboard`,
    BIOMARKERS: `/app/biomarkers`,
    RECOMMENDATIONS: `/app/recommendations`,
    CUSTOMER_MANAGEMENT: `/app/customer-management`,
    CUSTOMER_RESULTS: `/app/customer-results`,
    CONTENT_PLAYGROUND: '/app/content-playground',
    PROGRAMS: '/app/programs',
    FITNESS: '/app/fitness',
    MEALPLAN: '/app/mealplan',
    UI_CUSTOMISATION: '/app/ui-customisation',
    HEALTH_PROGRAM: '/app/health-program/',
    ORGANISATIONS: '/app/organisations',
    CONTENTS: '/app/contents',
    PARTNERS: '/app/partners',
    PRACTITIONERS: '/app/practitioners',
    SAMPLES_PAGE: '/app/samples',
};

export const BLOOD_BIOMARKERS_SERVICE_NAME = "Blood biomarkers";
export const DNA_BIOMARKERS_SERVICE_NAME = "DNAm biomarkers";
export const SKIN_BIOMARKERS_SERVICE_NAME = "Skin biomarkers";
export const FOOD_INTOLERANCE_SERVICE_NAME = "Food Intolerance";
export const DASHBOARD_UI_CUSTOMISATION_SERVICE_NAME = "Dashboard UI Customisation";

export const SIDEBAR_SERVICE_MAP = {
    "SIDEBAR.DASHBOARD": "Admin Dashboard",
    "SIDEBAR.BIOMARKERS": [BLOOD_BIOMARKERS_SERVICE_NAME, DNA_BIOMARKERS_SERVICE_NAME, SKIN_BIOMARKERS_SERVICE_NAME],
    "SIDEBAR.FOOD_INTOLERANCE": FOOD_INTOLERANCE_SERVICE_NAME,
    "SIDEBAR.RECOMMENDATIONS": "Recommendations",
    "SIDEBAR.CUSTOMER_MANAGEMENT": "Customer Management",
    "SIDEBAR.CUSTOMER_RESULTS": "Customers Result",
    "SIDEBAR.NUTRITION": "Nutrition programs",
    "SIDEBAR.FITNESS": "Fitness programs",
    "SIDEBAR.WELLNESS": "Wellness programs",
    "SIDEBAR.CONTENT": "Content",
    "SIDEBAR.FOOD_AND_RECIPES": "Food & Recipes",
    "SIDEBAR.USER_SEGMENTS": "User Segments",
    "SIDEBAR.UI_CUSTOMISATION": "UI Customisation",
    "SIDEBAR.GENERAL": "UI Customisation",
    "SIDEBAR.UI_SETTINGS": DASHBOARD_UI_CUSTOMISATION_SERVICE_NAME,
    "SIDEBAR.ADMIN_PANEL": "Admin UI Customisation",
    "SIDEBAR.EMAILS": "Emails",
    "SIDEBAR.DYNAMIC_WIDGETS": "Dynamic Widgets",
    "SIDEBAR.APP_CUSTOMIZATION": "App Customisation",
    "SIDEBAR.MEALPLAN": "Nutrition programs",
    "SIDEBAR.ADMINS": "Admins",
    "SIDEBAR.PRACTITIONERS": "Practitioners",
    "SIDEBAR.NOTIFICATIONS": "Mobile Notifications",
    "SIDEBAR.SAMPLES_PAGE": "Samples page"
  };

export const ROLE_SECTION_SERVICE_NAMES = {
  GP_REPORT: "GPReport",
  MIND_AND_BODY: "Mind and Body",
  UPLOADING_RESULTS_FROM_OTHER_LABS: "Uploading results from other labs",
};
